import React, { Component } from "react";
import { PAGE_SIZE } from "../ComponentList";
import ApiManager from "../../../managers/ApiManager";
import { showToast, TOAST_TYPE } from "deskera-ui-library";

/*
PROPS
- data
- borderStyle
- viewType
*/

class ImageText extends Component {
  inputOpenFileRef;

  constructor(props) {
    super(props);
    this.inputOpenFileRef = React.createRef();
    this.state = {
      inlineEditing: false,
      selectedImageIndex: 0,
    };
  }
  componentWillUnmount() {
    this.setState({ inlineEditing: false });
  }
  render() {
    return (
      <div
        style={{
          ...this.props.data.style,
          ...this.props.borderStyle,
          borderSpacing: "" + this.props.data.style.cellSpacing + "px 0px",
          maxWidth: "100%",
        }}
      >
        {this.getImageTextItem(this.props.data.value, this.props.data.style)}
        {this.getImagePicker()}
      </div>
    );
  }

  getImageTextItem(items, style) {
    let arr = [];
    items.forEach((item, index) => {
      arr.push(this.getImageTextContainer(item, style, index));
    });
    return arr;
  }

  getImageTextContainer(data, style, index) {
    return (
      <div style={{ width: "100%", display: "inline" }}>
        <img
          src={data.image}
          alt="Item"
          style={{
            width:
              this.props.viewType === PAGE_SIZE.PHONE
                ? "100%"
                : `${style.imageSize}%`,
            float: style.imageAlign,
            borderRadius: style.imageRadius,
          }}
          draggable={false}
          onDoubleClick={() => {
            this.setState({ selectedImageIndex: index });
            this.inputOpenFileRef.current.click();
          }}
        />
        {style.imageAlign === "left" &&
          this.props.viewType !== PAGE_SIZE.PHONE && (
            <div
              style={{
                float: "left",
                height: "100%",
                width: `${style.cellSpacing}%`,
              }}
            ></div>
          )}
        <div
          style={{
            float: style.imageAlign === "left" ? "right" : "left",
            margin: "10px 0",
            textAlign: style.textAlign,
            width:
              this.props.viewType === PAGE_SIZE.PHONE
                ? "100%"
                : `${style.containerSpacing}%`,
            wordBreak: "break-word",
          }}
        >
          {data.title && (
            <div
              style={{
                marginTop: 4,
                color: style.titleColor,
                fontSize: style.titleSize,
              }}
              dangerouslySetInnerHTML={{ __html: data.title }}
              contentEditable={this.state.inlineEditing}
              onDoubleClick={() => {
                this.setState({ inlineEditing: true });
              }}
              onBlur={(e) => {
                e.preventDefault();
                this.setState({ inlineEditing: false });
                this.props.onTextChange(e.target.innerHTML, index, "title");
              }}
            />
          )}
          {data.description && (
            <div
              style={{
                marginTop: 4,
                color: style.descriptionColor,
                fontSize: style.descriptionSize,
              }}
              dangerouslySetInnerHTML={{ __html: data.description }}
              contentEditable={this.state.inlineEditing}
              onDoubleClick={() => {
                this.setState({ inlineEditing: true });
              }}
              onBlur={(e) => {
                e.preventDefault();
                this.setState({ inlineEditing: false });
                this.props.onTextChange(
                  e.target.innerHTML,
                  index,
                  "description"
                );
              }}
            />
          )}
        </div>
        {style.imageAlign === "right" &&
          this.props.viewType !== PAGE_SIZE.PHONE && (
            <div
              style={{
                float: "left",
                height: "100%",
                width: `${style.cellSpacing}%`,
              }}
            ></div>
          )}
      </div>
    );
  }
  getImagePicker = () => {
    return (
      <input
        type="file"
        accept="image/*"
        ref={this.inputOpenFileRef}
        style={{ display: "none" }}
        onChange={(e) => {
          this.uploadImageToAWS(e.target.files[0]);
        }}
      />
    );
  };

  uploadImageToAWS(imageData) {
    ApiManager.getUploadFileURL(
      imageData,
      (url) => {
        this.props.onValueChange(url, this.state.selectedImageIndex);
      },
      (err) => {
        showToast("Image upload failed", TOAST_TYPE.FAILURE);
      }
    );
  }
}

export default ImageText;
